import {ChangeDetectionStrategy, Component, computed, input, output} from '@angular/core';
import {FormValue, TranslatePipe} from '@brunata-angular/util';
import {VendorModelListComponent} from './vendor-model-list/vendor-model-list.component';
import {VendorModelsFormGroup} from '../../event-alarm.model';
import {uniqBy} from 'lodash-es';

@Component({
    selector: 'app-select-vendor-models',
    imports: [TranslatePipe, VendorModelListComponent],
    templateUrl: './select-vendor-models.component.html',
    styleUrl: './select-vendor-models.component.scss',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectVendorModelsComponent {
    vendorModels = input.required<FormValue<VendorModelsFormGroup>[]>();
    vendorModelsChange = output<FormValue<VendorModelsFormGroup>[]>();

    readonly viewSignal = computed(() => {
        const vendorModels = this.vendorModels();
        return {
            availableVendorModels: vendorModels.filter(model => model.selected === false),
            selectedVendorModels: vendorModels.filter(model => model.selected === true),
            anyUnsupportedEventTypes: vendorModels.some(
                model => model.isEventTypeSupported === false,
            ),
            allEventTypesUnsupported: vendorModels.every(
                model => model.isEventTypeSupported === false,
            ),
            vendorModels,
        };
    });

    vendorModelsSelected(
        vendorModels: FormValue<VendorModelsFormGroup>[],
        selected: boolean,
    ): void {
        const currentModels = this.vendorModels();

        const modelIdsToUpdate = uniqBy(vendorModels, model => model.vendorModelId);

        const updatedModels = currentModels.map(current =>
            modelIdsToUpdate.some(updated => updated.vendorModelId === current.vendorModelId)
                ? {...current, selected}
                : current,
        );

        this.vendorModelsChange.emit(updatedModels);
    }
}
